<template>
  <div
    v-if="!$freeParticulier() || form.projets.length > 0"
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <h3 class="m-5 md:m-15 2xl:m-20">
      Projets
    </h3>

    <!-- BEGIN duration informations -->
    <div
      class="border-2 border-gray-600 border-opacity-25 border-dashed rounded-2xl xl:mx-28 xxl:mx-40 mb-10 p-5"
    >
      <div class="text-lg text-indigo-600 font-normal text-center">
        Durée totale des accompagnements
      </div>
      <div class="text-base text-center">
        <br />
        Total: {{ totalDuration.total[0].h }}h
        {{
          (totalDuration.total[0].min < 10 ? '0' : '') +
            totalDuration.total[0].min
        }}min réel
        <div class="inline-flex text-gray-600">
          ({{ totalDuration.total[1].h }}h
          {{
            (totalDuration.total[1].min < 10 ? '0' : '') +
              totalDuration.total[1].min
          }}min estimées)
        </div>
        <br />
        Personnel: {{ totalDuration.perso[0].h }}h
        {{
          (totalDuration.perso[0].min < 10 ? '0' : '') +
            totalDuration.perso[0].min
        }}min réel
        <div class="inline-flex text-gray-600">
          ({{ totalDuration.perso[1].h }}h
          {{
            (totalDuration.perso[1].min < 10 ? '0' : '') +
              totalDuration.perso[1].min
          }}min estimées)
        </div>
        <br />
        Socio-professionnel: {{ totalDuration.socio[0].h }}h
        {{
          (totalDuration.socio[0].min < 10 ? '0' : '') +
            totalDuration.socio[0].min
        }}min réel
        <div class="inline-flex text-gray-600">
          ({{ totalDuration.socio[1].h }}h
          {{
            (totalDuration.socio[1].min < 10 ? '0' : '') +
              totalDuration.socio[1].min
          }}min estimées)
        </div>
        <br />
        Professionnel: {{ totalDuration.pro[0].h }}h
        {{
          (totalDuration.pro[0].min < 10 ? '0' : '') + totalDuration.pro[0].min
        }}min réel
        <div class="inline-flex text-gray-600">
          ({{ totalDuration.pro[1].h }}h
          {{
            (totalDuration.pro[1].min < 10 ? '0' : '') +
              totalDuration.pro[1].min
          }}min estimées)
        </div>
      </div>
    </div>
    <!-- END duration informations -->

    <!-- BEGIN button to add a project -->
    <add-button
      v-if="$can(infosPage.name_page + '_edit', infosPass.id_pass)"
      @add="addProject()"
      libelle="Ajouter un projet"
      class="mx-5 md:mx-15 2xl:mx-20"
    />
    <!-- END button to add a project -->

    <!-- BEGIN Header table of list project -->
    <div v-if="form.projets.length > 0">
      <list-grid
        :list-items="form.projets"
        :is-accordion-items="true"
        @displayNum="
          (num) => {
            projectDisplayed = num;
          }
        "
        ref="listProjects"
      >
        <template #header>
          <div class="col-start-3 md:col-start-2 col-span-5 md:col-span-3">
            Période
          </div>
          <div class="hidden md:block md:col-span-2">
            Type
          </div>
          <div class="col-span-5 md:col-span-2">
            Intitulé
          </div>
          <div class="hidden md:block md:col-span-1">
            Temps
          </div>
          <div class="hidden md:block md:col-span-2">
            Etat
          </div>
          <div class="hidden md:block md:col-span-1" />
          <!--Bouton PDF-->
        </template>

        <template #accordionDescription="{ item, num }">
          <icon
            class="text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300"
            :class="{ 'rotate-90': projectDisplayed == num }"
            name="chevron-right"
          />
          <div
            class="col-span-5 md:col-span-3 text-base font-normal justify-self-start"
          >
            <!-- Période -->
            <span
              v-if="
                item.min_debut_accompagnement_projet != '' &&
                  item.min_debut_accompagnement_projet != null
              "
            >
              {{
                (
                  '0' + new Date(item.min_debut_accompagnement_projet).getDate()
                ).slice(-2)
              }}/{{
                (
                  '0' +
                  (new Date(item.min_debut_accompagnement_projet).getMonth() +
                    1)
                ).slice(-2)
              }}/{{
                new Date(item.min_debut_accompagnement_projet).getFullYear()
              }}
            </span>
            <span
              v-if="
                item.min_debut_accompagnement_projet != '' &&
                  item.min_debut_accompagnement_projet != null &&
                  item.max_fin_accompagnement_projet != '' &&
                  item.max_fin_accompagnement_projet != null
              "
            >
              -
            </span>
            <span
              v-if="
                item.max_fin_accompagnement_projet != '' &&
                  item.max_fin_accompagnement_projet != null
              "
            >
              {{
                (
                  '0' + new Date(item.max_fin_accompagnement_projet).getDate()
                ).slice(-2)
              }}/{{
                (
                  '0' +
                  (new Date(item.max_fin_accompagnement_projet).getMonth() + 1)
                ).slice(-2)
              }}/{{
                new Date(item.max_fin_accompagnement_projet).getFullYear()
              }}
            </span>
          </div>
          <div
            class="hidden md:block md:col-span-2 text-base font-normal justify-self-start"
          >
            <!-- Type -->
            <tag
              :libelle="item.type_projet"
              :theme-color="
                item.type_projet == 'Professionnel'
                  ? 'indigo'
                  : item.type_projet == 'Personnel'
                    ? 'pink'
                    : item.type_projet == 'Socio-professionnel'
                      ? 'teal'
                      : 'default'
              "
            />
          </div>

          <div
            class="col-span-5 md:col-span-2 text-base font-normal justify-self-start"
          >
            <!-- Intitulé -->
            {{ item.intitule_projet }}
          </div>

          <div
            class="hidden lg:block md:col-span-1 text-base font-normal justify-self-start"
          >
            <!-- Temps -->
            <span v-if="item.total_temps_accompagnement > 0">
              {{ item.total_temps_accompagnement.toFixed(0) }}h
            </span>
          </div>

          <div class="hidden md:inline-block md:col-span-2">
            <!-- Etat de la décision -->
            <span
              class="text-base font-normal"
              :class="{
                'text-indigo-600 ':
                  item.etat_decision_projet == 'Soumis à l\'étude',
                'text-pink-600': item.etat_decision_projet == 'Refusé',
                'text-teal-600 ': item.etat_decision_projet == 'Programmé',
              }"
            >
              {{ item.etat_decision_projet }}
            </span>
          </div>

          <div class="hidden md:block md:col-span-1">
            <circle-button
              v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
              icon="download"
              label="Exporter le projet en PDF"
              @buttonClick="exportToPDF(item)"
            />
          </div>
        </template>

        <template #accordionContent="{ item, num }">
          <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <div class="col-span-full text-base text-indigo-600 font-normal">
              PROJET
            </div>

            <input-select
              name="type_projet"
              libelle="Type de projet"
              size="3"
              :necessary="true"
              :value="item.type_projet"
              @input="
                (newValue) => {
                  item.type_projet = newValue;
                }
              "
              :datas="[
                { value: 'Personnel' },
                { value: 'Professionnel' },
                { value: 'Socio-professionnel' },
              ]"
              class="md:col-span-6"
            />
            <input-text
              name="intitule_projet"
              libelle="Intitulé du projet"
              :necessary="true"
              :value="item.intitule_projet"
              @input="
                (newValue) => {
                  item.intitule_projet = newValue;
                }
              "
              class="md:col-span-6"
            />
            <input-text-area
              name="objectifs_projet"
              libelle="Objectifs "
              :necessary="true"
              size="4"
              :value="item.objectifs_projet"
              @input="
                (newValue) => {
                  item.objectifs_projet = newValue;
                }
              "
              class="md:col-span-6"
            />
            <input-text-area
              name="comment_projet"
              libelle="Commentaire"
              :necessary="false"
              size="4"
              :value="item.comment_projet"
              @input="
                (newValue) => {
                  item.comment_projet = newValue;
                }
              "
              class="md:col-span-6"
            />
            <input-text-area
              name="moyens_projet"
              libelle="Moyens mis en oeuvre"
              :necessary="false"
              size="4"
              :value="item.moyens_projet"
              @input="
                (newValue) => {
                  item.moyens_projet = newValue;
                }
              "
              class="md:col-span-6"
            />

            <!-- BEGIN list of referents -->
            <div
              class="col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
              v-for="(referent, indexReferent) in item.referents"
              :key="referent.nom_referent"
              :class="{
                'border-b w-full pb-5 border-gray-600':
                  $isMobile() && indexReferent < item.referents.length - 1,
              }"
            >
              <delete-button
                v-if="item.referents.length > 1"
                class="col-span-1 lg:pt-8"
                :libelle="$isMobile() ? 'Supprimer ce référent' : ''"
                @del="deleteReferent(item.referents, indexReferent)"
              />

              <input-text
                name="accompagnateur_projet"
                libelle="Référent accompagnateur"
                :necessary="true"
                :value="referent.accompagnateur_projet"
                @input="
                  (newValue) => {
                    referent.accompagnateur_projet = newValue;
                  }
                "
                class="md:col-span-3"
              />
              <date-picker
                name="debut_accompagnement_projet"
                :necessary-date="true"
                libelle="Date de début d'accompagnement du projet"
                class="col-span-full md:col-span-4"
                format="dd/MM/yyyy"
                initialview="year"
                :value="referent.debut_accompagnement_projet"
                @input="
                  (newValue) => {
                    if (
                      (referent.fin_accompagnement_projet == '' &&
                        referent.fin_accompagnement_projet == null) ||
                      $verifyDates({
                        debut: newValue,
                        fin: referent.fin_accompagnement_projet,
                      })
                    ) {
                      referent.debut_accompagnement_projet = newValue;
                      setMinDateDebutReferent(num);
                    } else {
                      badDates();
                      referent.debut_accompagnement_projet = '';
                    }
                  }
                "
              />
              <date-picker
                name="fin_accompagnement_projet"
                :necessary-date="true"
                libelle="Date de fin d'accompagnement du projet"
                class="col-span-full md:col-span-4"
                format="dd/MM/yyyy"
                initialview="year"
                :value="referent.fin_accompagnement_projet"
                @input="
                  (newValue) => {
                    if (
                      (referent.debut_accompagnement_projet == '' &&
                        referent.debut_accompagnement_projet == null) ||
                      $verifyDates({
                        debut: referent.debut_accompagnement_projet,
                        fin: newValue,
                      })
                    ) {
                      referent.fin_accompagnement_projet = newValue;
                      setMaxDateDebutReferent(num);
                    } else {
                      badDates();
                      referent.fin_accompagnement_projet = '';
                    }
                  }
                "
              />

              <div
                class="col-start-1 col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
              >
                <div
                  class="col-span-full md:col-span-3"
                  :class="{
                    'lg:col-start-2': item.referents.length > 1,
                  }"
                >
                  <info-bulle-hover
                    name="tempsestimetooltip"
                    libelle="Temps d'accompagnement estimé"
                    :is-display-tooltip="isEstimatedTimeTooltipDisplay"
                  />
                  <p
                    @mouseover="isEstimatedTimeTooltipDisplay = true"
                    @mouseleave="isEstimatedTimeTooltipDisplay = false"
                    v-html="'Temps d\'accomp. estimé'"
                    class="text-sm text-gray-600 font-normal truncate w-full mb-2"
                  />
                  <div class="w-full flex">
                    <div class="w-1/2 mr-2">
                      <input-select
                        :name="
                          'temps_accompagnement_estime_hour' + indexReferent
                        "
                        :necessary="true"
                        :datas="nbheuresPossible"
                        :value="referent.temps_accompagnement_estime_hour"
                        @input="
                          (newValue) => {
                            referent.temps_accompagnement_estime_hour =
                              newValue;
                          }
                        "
                        class=""
                        libelle=""
                        placeholder="h"
                        fixed-text=" h"
                      />
                    </div>
                    <div class="w-1/2 ml-2">
                      <input-select
                        :name="
                          'temps_accompagnement_estime_minute' + indexReferent
                        "
                        :necessary="true"
                        :datas="nbminutesPossible"
                        :value="referent.temps_accompagnement_estime_minute"
                        @input="
                          (newValue) => {
                            referent.temps_accompagnement_estime_minute =
                              newValue;
                          }
                        "
                        class=""
                        libelle=""
                        placeholder="min"
                        fixed-text=" min"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-span-full md:col-span-3">
                  <info-bulle-hover
                    name="tempsreeltooltip"
                    libelle="Temps d'accompagnement réel"
                    :is-display-tooltip="isRealTimeTooltipDisplay"
                  />
                  <p
                    @mouseover="isRealTimeTooltipDisplay = true"
                    @mouseleave="isRealTimeTooltipDisplay = false"
                    v-html="'Temps d\'accomp. réel'"
                    class="text-sm text-gray-600 font-normal truncate w-full mb-2"
                  />
                  <div class="w-full flex">
                    <div class="w-1/2 mr-2">
                      <input-select
                        :name="'temps_accompagnement_reel_hour' + indexReferent"
                        :necessary="true"
                        :datas="nbheuresPossible"
                        :value="referent.temps_accompagnement_reel_hour"
                        @input="
                          (newValue) => {
                            referent.temps_accompagnement_reel_hour = newValue;
                            setTotalTempsAccompagnement(num);
                          }
                        "
                        class=""
                        libelle=""
                        placeholder="h"
                        fixed-text=" h"
                      />
                    </div>
                    <div class="w-1/2 ml-2">
                      <input-select
                        :name="
                          'temps_accompagnement_reel_minute' + indexReferent
                        "
                        :necessary="true"
                        :datas="nbminutesPossible"
                        :value="referent.temps_accompagnement_reel_minute"
                        @input="
                          (newValue) => {
                            referent.temps_accompagnement_reel_minute =
                              newValue;
                            setTotalTempsAccompagnement(num);
                          }
                        "
                        class=""
                        libelle=""
                        placeholder="min"
                        fixed-text=" min"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END list of referents -->

            <!-- BEGIN Button to add a referent -->
            <div
              v-if="
                $can(page + '_edit', idpass) ||
                  page === Constants.PAGE_NEOPASS_FORM_DOCUMENTS
              "
              class="col-span-full w-max-content w-max cursor-pointer flex hover:font-medium"
              @click="addReferent(num)"
            >
              <span class="plus-button 2xl:h-10 2xl:w-10">
                <icon name="plus" />
              </span>
              <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
                Ajouter un référent accompagnateur
              </span>
            </div>
            <div
              v-else
              class="col-span-full w-max-content w-max cursor-not-allowed flex"
            >
              <span class="plus-button 2xl:h-10 2xl:w-10">
                <icon name="plus" />
              </span>
              <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
                Ajouter un référent accompagnateur
              </span>
            </div>
            <!-- END Button to add a referent -->

            <input-select
              name="etat_decision_projet"
              libelle="Etat de la décision"
              size="3"
              :value="item.etat_decision_projet"
              @input="
                (newValue) => {
                  item.etat_decision_projet = newValue;
                }
              "
              :datas="[
                { value: 'Soumis à l\'étude' },
                { value: 'Refusé' },
                { value: 'Programmé' },
              ]"
              class="md:col-span-6"
            />

            <div
              class="col-span-full flex text-base text-indigo-600 font-normal"
            >
              <p>STAGE, FORMATION ET ACCOMPAGNEMENT</p>
              <info-bulle
                libelle="ex : rendez-vous psychologue"
                :is-libelle-input="true"
              />
            </div>

            <!-- BEGIN Button to add "Stage" or "Formation" -->

            <div class="col-span-full w-max mb-10 relative">
              <add-button
                @add="displayDropdownMenu"
                libelle="Ajouter un stage, une formation ou un accompagnement"
                :with-dropdown="true"
              />

              <!-- BEGIN Menu dropdown stage or formation -->
              <transition
                enter-active-class="ease-out duration-150"
                enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div
                  class="z-20 absolute right-0 top-8 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
                  v-if="dropDownMenu"
                  v-clickOutside="forceHide"
                >
                  <div class="mx-5 my-3 text-left">
                    <div
                      class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                      v-for="(type, indexPeriode) in typePeriodes"
                      :key="indexPeriode"
                      @click="addPeriode(num, type)"
                    >
                      {{ type }}
                    </div>
                  </div>
                </div>
              </transition>
              <!-- END Menu dropdown stage or formation -->
            </div>
            <!-- END Button to add "Stage" or "Formation" -->

            <div
              class="col-span-full"
              v-if="form.projets[num].periodes.length > 0"
            >
              <!-- BEGIN Header of accordion for stages and formations -->
              <div
                class="text-lg text-gray-600 h-16 2xl:h-24 grid grid-cols-12 gap-x-4 place-content-center"
              >
                <div
                  class="col-start-3 col-span-4 md:col-start-2 md:col-span-2 xl:col-start-2 xl:col-span-3"
                >
                  Période
                </div>
                <div class="hidden md:block md:col-span-3">
                  Type
                </div>
                <div
                  class="col-span-4 md:col-span-3 xl:col-span-2 xxl:col-span-3"
                >
                  Intitulé
                </div>
                <div class="hidden md:block md:col-span-3 xxl:col-span-2">
                  Etat
                </div>
              </div>
              <!-- END Header of accordion for stages and formations -->

              <!--BEGIN list of periode-->
              <div
                v-for="(per, i) in item.periodes"
                :key="i"
                class="even:bg-gray-200 even:bg-opacity-50"
              >
                <!-- BEGIN periode informations of accordion -->
                <div
                  class="h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center items-center cursor-pointer"
                  :class="{
                    'bg-indigo-200 border-l-2 border-indigo-600':
                      periodeDisplayed == i,
                  }"
                  @click="displayPeriode(i)"
                >
                  <icon
                    class="col-span-2 md:col-span-1 text-pink-600 place-self-center transform transition-transform ease-in-out duration-300"
                    :class="{
                      'rotate-90': periodeDisplayed == i,
                    }"
                    name="chevron-right"
                  />

                  <div class="col-span-4 md:col-span-2 xl:col-span-3 text-base">
                    <!-- Période -->
                    <span v-if="per.debut_periode">
                      {{
                        ('0' + new Date(per.debut_periode).getDate()).slice(-2)
                      }}/{{
                        (
                          '0' +
                          (new Date(per.debut_periode).getMonth() + 1)
                        ).slice(-2)
                      }}/{{ new Date(per.debut_periode).getFullYear() }}
                    </span>
                    <span class="hidden lg:inline">-</span>
                    <span
                      class="hidden lg:inline"
                      v-if="per.debut_periode && !per.fin_periode"
                    >
                      En cours
                    </span>
                    <span
                      v-if="per.fin_periode"
                      class="hidden lg:inline"
                    >
                      {{
                        ('0' + new Date(per.fin_periode).getDate()).slice(-2)
                      }}/{{
                        (
                          '0' +
                          (new Date(per.fin_periode).getMonth() + 1)
                        ).slice(-2)
                      }}/{{ new Date(per.fin_periode).getFullYear() }}
                    </span>
                  </div>

                  <div class="hidden md:block md:col-span-3">
                    <!-- Type -->
                    <tag
                      :libelle="per.type"
                      :theme-color="
                        per.type == 'Stage'
                          ? 'orange'
                          : per.type == 'Formation'
                            ? 'white'
                            : 'teal'
                      "
                    />
                  </div>

                  <div
                    class="col-span-4 md:col-span-3 xl:col-span-2 xxl:col-span-3 text-base justify-self-start"
                  >
                    <!-- Intitulé -->
                    {{ per.intitule_periode }}
                  </div>

                  <div class="hidden md:block md:col-span-3 xxl:col-span-2">
                    <!-- Etat -->
                    <span
                      class="py-1 text-base"
                      :class="{
                        'text-indigo-600':
                          per.etat_decision == 'Soumise à l\'étude' ||
                          per.etat_decision == 'Soumis à l\'étude',
                        'text-pink-600':
                          per.etat_decision == 'Refusée' ||
                          per.etat_decision == 'Refusé',
                        'text-teal-600 ':
                          per.etat_decision == 'Programmée' ||
                          per.etat_decision == 'Programmé',
                      }"
                    >
                      {{ per.etat_decision }}
                    </span>
                  </div>
                </div>
                <!-- END periode informations of accordion -->

                <!-- BEGIN content each stage or formation (into the current project) -->
                <transition-group
                  enter-active-class="ease-out duration-300"
                  enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-active-class="ease-in duration-200"
                  leave-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <!-- BEGIN Form Stage -->
                  <div
                    v-show="periodeDisplayed === i"
                    :key="'stage' + i"
                    :id="`periode${i}`"
                  >
                    <div
                      v-if="per.type === 'Stage'"
                      class="bg-white px-5 pt-5 md:px-15 md:pt-15 grid grid-cols-12 gap-x-4 gap-y-10"
                    >
                      <input-text
                        class="md:col-span-3"
                        name="intitule_periode"
                        :necessary="true"
                        libelle="Intitulé du stage"
                        :value="per.intitule_periode"
                        @input="
                          (newValue) => {
                            per.intitule_periode = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="nom_structure"
                        :necessary="true"
                        libelle="Nom de la structure d'accueil"
                        :value="per.nom_structure"
                        @input="
                          (newValue) => {
                            per.nom_structure = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="localisation_stage"
                        :necessary="true"
                        libelle="Localisation"
                        :value="per.localisation_stage"
                        @input="
                          (newValue) => {
                            per.localisation_stage = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="referent_stage"
                        :necessary="true"
                        libelle="Référent / interlocuteur principal"
                        :value="per.referent_stage"
                        @input="
                          (newValue) => {
                            per.referent_stage = newValue;
                          }
                        "
                      />
                      <date-picker
                        name="debut_periode"
                        :necessary-date="true"
                        libelle="Date de début du stage"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.debut_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.fin_periode == '' &&
                                per.fin_periode == null) ||
                              $verifyDates({
                                debut: newValue,
                                fin: per.fin_periode,
                              })
                            ) {
                              per.debut_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.debut_periode = '';
                            }
                          }
                        "
                      />
                      <date-picker
                        name="fin_periode"
                        :necessary-date="true"
                        libelle="Date de fin du stage"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.fin_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.debut_periode == '' &&
                                per.debut_periode == null) ||
                              $verifyDates({
                                debut: per.debut_periode,
                                fin: newValue,
                              })
                            ) {
                              per.fin_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.fin_periode = '';
                            }
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="duree_stage"
                        :necessary="true"
                        libelle="Durée (en h)"
                        :value="per.duree_stage"
                        @input="
                          (newValue) => {
                            per.duree_stage = newValue;
                          }
                        "
                      />
                      <input-select
                        name="type_stage"
                        :necessary="true"
                        libelle="Type de stage"
                        size="3"
                        :value="per.type_stage"
                        @input="
                          (newValue) => {
                            per.type_stage = newValue;
                          }
                        "
                        :datas="[{ value: 'Interne' }, { value: 'Externe' }]"
                        class="md:col-span-3"
                      />
                      <input-select
                        name="milieu_stage"
                        :necessary="true"
                        libelle="Stage en milieu"
                        size="3"
                        :value="per.milieu_stage"
                        @input="
                          (newValue) => {
                            per.milieu_stage = newValue;
                          }
                        "
                        :datas="[{ value: 'Ordinaire' }, { value: 'Protégé' }]"
                        class="md:col-span-3"
                      />
                      <input-select
                        name="caracteristique_stage"
                        :necessary="true"
                        libelle="Caracteristiques du stage"
                        size="3"
                        :value="per.caracteristique_stage"
                        @input="
                          (newValue) => {
                            per.caracteristique_stage = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Application' },
                          { value: 'Observation' },
                        ]"
                        class="md:col-span-3"
                      />
                      <input-select
                        name="etat_decision"
                        :necessary="true"
                        libelle="Etat de la décision"
                        size="3"
                        :value="per.etat_decision"
                        @input="
                          (newValue) => {
                            per.etat_decision = newValue;
                          }
                        "
                        :datas="[
                          {
                            value: 'Soumis à l\'étude',
                          },
                          { value: 'Refusé' },
                          { value: 'Programmé' },
                        ]"
                        class="md:col-span-3"
                      />
                      <input-text-area
                        name="objectifs_resultats"
                        :necessary="true"
                        libelle="Objectifs / Résultats attendus"
                        size="4"
                        :value="per.objectifs_resultats"
                        @input="
                          (newValue) => {
                            per.objectifs_resultats = newValue;
                          }
                        "
                        class="lg:col-start-1 md:col-span-6"
                      />
                      <input-text-area
                        name="commentaire_stage"
                        libelle="Commentaires"
                        size="4"
                        :value="per.commentaire_stage"
                        @input="
                          (newValue) => {
                            per.commentaire_stage = newValue;
                          }
                        "
                        class="md:col-span-6"
                      />
                      <div
                        class="col-span-full w-max-content w-max cursor-pointer flex hover:font-medium"
                        @click="deletePeriode(item.periodes, i)"
                      >
                        <span class="minus-button 2xl:h-10 2xl:w-10">
                          <icon name="close" />
                        </span>
                        <span
                          class="text-gray-600 text-base ml-3 mt-1.5 mb-10 flex-initial"
                        >
                          Supprimer ce stage
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- END stage -->

                  <!-- BEGIN formation -->
                  <div
                    v-show="periodeDisplayed === i"
                    :key="'formation' + i"
                  >
                    <div
                      v-if="per.type === 'Formation'"
                      class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
                    >
                      <input-text
                        class="md:col-span-3"
                        name="intitule_periode"
                        :necessary="true"
                        libelle="Intitulé de la formation"
                        :value="per.intitule_periode"
                        @input="
                          (newValue) => {
                            per.intitule_periode = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="organisme_formation"
                        :necessary="true"
                        libelle="Organisme de formation"
                        :value="per.organisme_formation"
                        @input="
                          (newValue) => {
                            per.organisme_formation = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="localisation_formation"
                        :necessary="true"
                        libelle="Localisation"
                        :value="per.localisation_formation"
                        @input="
                          (newValue) => {
                            per.localisation_formation = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="referent_formation"
                        :necessary="true"
                        libelle="Référent / Interlocuteur principal"
                        :value="per.referent_formation"
                        @input="
                          (newValue) => {
                            per.referent_formation = newValue;
                          }
                        "
                      />
                      <date-picker
                        name="debut_periode"
                        :necessary-date="true"
                        libelle="Date de début de formation"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.debut_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.fin_periode == '' &&
                                per.fin_periode == null) ||
                              $verifyDates({
                                debut: newValue,
                                fin: per.fin_periode,
                              })
                            ) {
                              per.debut_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.debut_periode = '';
                            }
                          }
                        "
                      />
                      <date-picker
                        name="fin_periode"
                        :necessary-date="true"
                        libelle="Date de fin de formation"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.fin_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.debut_periode == '' &&
                                per.debut_periode == null) ||
                              $verifyDates({
                                debut: per.debut_periode,
                                fin: newValue,
                              })
                            ) {
                              per.fin_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.fin_periode = '';
                            }
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="duree_formation"
                        :necessary="true"
                        libelle="durée (en h)"
                        :value="per.duree_formation"
                        @input="
                          (newValue) => {
                            per.duree_formation = newValue;
                          }
                        "
                      />
                      <input-select
                        name="type_formation"
                        :necessary="true"
                        libelle="Type de formation"
                        :value="per.type_formation"
                        @input="
                          (newValue) => {
                            per.type_formation = newValue;
                          }
                        "
                        :datas="[{ value: 'Interne' }, { value: 'Externe' }]"
                        class="md:col-span-3"
                      />
                      <input-select
                        name="modalites_formation"
                        :necessary="true"
                        libelle="Modalités"
                        :value="per.modalites_formation"
                        @input="
                          (newValue) => {
                            per.modalites_formation = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Présentiel' },
                          { value: 'E-learning' },
                        ]"
                        class="md:col-span-3"
                      />

                      <input-select
                        name="dispositifs_formation"
                        :necessary="true"
                        libelle="Dispositifs retenus"
                        :value="per.dispositifs_formation"
                        @input="
                          (newValue) => {
                            per.dispositifs_formation = newValue;
                          }
                        "
                        :datas="[
                          {
                            value: 'Plan de Formation Cat 1 ou 2 ',
                          },
                          { value: 'PP' },
                          { value: 'CPF' },
                          { value: 'CEP' },
                          { value: 'CIF' },
                          { value: 'VAE' },
                          { value: 'BC' },
                          { value: 'RSFP' },
                          { value: 'Autres' },
                        ]"
                        class="md:col-span-3"
                      />
                      <transition
                        enter-active-class="ease-in duration-300"
                        enter-class="opacity-0"
                        leave-active-class="ease-out duration-300"
                        leave-to-class="opacity-0"
                      >
                        <input-text
                          v-if="per.dispositifs_formation === 'Autres'"
                          class="md:col-span-3"
                          name="dispositifs_formation_precis"
                          :necessary="true"
                          libelle="Précisez (si autre)"
                          :value="per.dispositifs_formation_precis"
                          @input="
                            (newValue) => {
                              per.dispositifs_formation_precis = newValue;
                            }
                          "
                        />
                      </transition>

                      <input-select
                        name="formation_suivie"
                        :necessary="true"
                        libelle="Formation suivie au titre de"
                        :value="per.formation_suivie"
                        @input="
                          (newValue) => {
                            per.formation_suivie = newValue;
                          }
                        "
                        :datas="[
                          {
                            value: 'Formation de professionnalisation',
                          },
                          {
                            value: 'Formation d\'intégration',
                          },
                          {
                            value: 'Formation de perfectionnement',
                          },
                          {
                            value:
                              'Formation de préparation aux concours et examens professionnels',
                          },
                          {
                            value: 'Formation personnelle',
                          },
                          { value: 'Autre' },
                        ]"
                        class="md:col-span-3"
                      />
                      <transition
                        enter-active-class="ease-in duration-300"
                        enter-class="opacity-0"
                        leave-active-class="ease-out duration-300"
                        leave-to-class="opacity-0"
                      >
                        <input-text
                          v-if="per.formation_suivie === 'Autre'"
                          class="md:col-span-3"
                          :necessary="true"
                          name="dispositifs_formation_precis"
                          libelle="Précisez (si autre)"
                          :value="per.formation_suivie_precis"
                          @input="
                            (newValue) => {
                              per.formation_suivie_precis = newValue;
                            }
                          "
                        />
                      </transition>

                      <input-select
                        name="etat_decision"
                        :necessary="true"
                        libelle="Etat de la décision"
                        :value="per.etat_decision"
                        @input="
                          (newValue) => {
                            per.etat_decision = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Programmée' },
                          {
                            value: 'Soumise à l\'étude',
                          },
                          { value: 'Refusée' },
                        ]"
                        class="md:col-span-3"
                      />
                      <input-text-area
                        name="objectifs_formation"
                        :necessary="true"
                        libelle="Objectifs pédagogiques"
                        size="4"
                        :value="per.objectifs_formation"
                        @input="
                          (newValue) => {
                            per.objectifs_formation = newValue;
                          }
                        "
                        class="lg:col-start-1 md:col-span-6"
                      />
                      <input-text-area
                        name="commentaire_formation"
                        libelle="Commentaires"
                        size="4"
                        :value="per.commentaire_formation"
                        @input="
                          (newValue) => {
                            per.commentaire_formation = newValue;
                          }
                        "
                        class="md:col-span-6"
                      />
                      <div
                        class="col-span-3 w-max-content w-max cursor-pointer flex hover:font-semibold"
                        @click="deletePeriode(item.periodes, i)"
                      >
                        <span class="minus-button">
                          <icon name="close" />
                        </span>
                        <span
                          class="text text-gray-600 text-sm ml-3 mt-1.5 mb-10 flex-initial"
                        >
                          Supprimer cette formation
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--END formation -->

                  <!-- BEGIN Accompagnement -->
                  <div
                    v-show="periodeDisplayed === i"
                    :key="'accompagnement' + i"
                  >
                    <div
                      v-if="per.type === 'Accompagnement'"
                      class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
                    >
                      <input-text
                        class="md:col-span-3"
                        name="intitule_periode"
                        :necessary="true"
                        libelle="Intitulé"
                        :value="per.intitule_periode"
                        @input="
                          (newValue) => {
                            per.intitule_periode = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="organisme_accompagnement"
                        :necessary="true"
                        libelle="Organisme"
                        :value="per.organisme_accompagnement"
                        @input="
                          (newValue) => {
                            per.organisme_accompagnement = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="localisation_accompagnement"
                        :necessary="true"
                        libelle="Localisation"
                        :value="per.localisation_accompagnement"
                        @input="
                          (newValue) => {
                            per.localisation_accompagnement = newValue;
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="referent_accompagnement"
                        :necessary="true"
                        libelle="Référent / Interlocuteur principal"
                        :value="per.referent_accompagnement"
                        @input="
                          (newValue) => {
                            per.referent_accompagnement = newValue;
                          }
                        "
                      />
                      <date-picker
                        name="debut_periode"
                        :necessary-date="true"
                        libelle="Date de début de l'accompagnement"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.debut_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.fin_periode == '' &&
                                per.fin_periode == null) ||
                              $verifyDates({
                                debut: newValue,
                                fin: per.fin_periode,
                              })
                            ) {
                              per.debut_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.debut_periode = '';
                            }
                          }
                        "
                      />
                      <date-picker
                        name="fin_periode"
                        :necessary-date="true"
                        libelle="Date de fin de l'accompagnement"
                        class="col-span-full md:col-span-3"
                        format="dd/MM/yyyy"
                        initialview="year"
                        :value="per.fin_periode"
                        @input="
                          (newValue) => {
                            if (
                              (per.debut_periode == '' &&
                                per.debut_periode == null) ||
                              $verifyDates({
                                debut: per.debut_periode,
                                fin: newValue,
                              })
                            ) {
                              per.fin_periode = newValue;
                              sortPeriodes(num);
                            } else {
                              badDates();
                              per.fin_periode = '';
                            }
                          }
                        "
                      />
                      <input-text
                        class="md:col-span-3"
                        name="duree_accompagnement"
                        :necessary="true"
                        libelle="durée (en h)"
                        :value="per.duree_accompagnement"
                        @input="
                          (newValue) => {
                            per.duree_accompagnement = newValue;
                          }
                        "
                      />
                      <input-select
                        name="type_accompagnement"
                        :necessary="true"
                        libelle="Type d'accompagnement"
                        :value="per.type_accompagnement"
                        @input="
                          (newValue) => {
                            per.type_accompagnement = newValue;
                          }
                        "
                        :datas="[{ value: 'Interne' }, { value: 'Externe' }]"
                        class="md:col-span-3"
                      />
                      <input-select
                        name="modalites_accompagnement"
                        :necessary="true"
                        libelle="Modalités"
                        :value="per.modalites_accompagnement"
                        @input="
                          (newValue) => {
                            per.modalites_accompagnement = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Présentiel' },
                          { value: 'E-learning' },
                        ]"
                        class="md:col-span-3"
                      />

                      <input-select
                        name="dispositifs_accompagnement"
                        :necessary="true"
                        libelle="Dispositifs retenus"
                        :value="per.dispositifs_accompagnement"
                        @input="
                          (newValue) => {
                            per.dispositifs_accompagnement = newValue;
                          }
                        "
                        :datas="[
                          {
                            value: 'Plan de Formation Cat 1 ou 2 ',
                          },
                          { value: 'PP' },
                          { value: 'CPF' },
                          { value: 'CEP' },
                          { value: 'CIF' },
                          { value: 'VAE' },
                          { value: 'BC' },
                          { value: 'RSFP' },
                          { value: 'Autres' },
                        ]"
                        class="md:col-span-3"
                      />
                      <transition
                        enter-active-class="ease-in duration-300"
                        enter-class="opacity-0"
                        leave-active-class="ease-out duration-300"
                        leave-to-class="opacity-0"
                      >
                        <input-text
                          v-if="per.dispositifs_accompagnement === 'Autres'"
                          class="md:col-span-3"
                          name="dispositifs_accompagnement_precis"
                          :necessary="true"
                          libelle="Précisez (si autre)"
                          :value="per.dispositifs_accompagnement_precis"
                          @input="
                            (newValue) => {
                              per.dispositifs_accompagnement_precis = newValue;
                            }
                          "
                        />
                      </transition>

                      <input-select
                        name="etat_decision"
                        :necessary="true"
                        libelle="Etat de la décision"
                        :value="per.etat_decision"
                        @input="
                          (newValue) => {
                            per.etat_decision = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Programmée' },
                          {
                            value: 'Soumise à l\'étude',
                          },
                          { value: 'Refusée' },
                        ]"
                        class="md:col-span-3"
                      />
                      <input-text-area
                        name="objectifs_accompagnement"
                        :necessary="true"
                        libelle="Objectifs pédagogiques"
                        size="4"
                        :value="per.objectifs_accompagnement"
                        @input="
                          (newValue) => {
                            per.objectifs_accompagnement = newValue;
                          }
                        "
                        class="lg:col-start-1 md:col-span-6"
                      />
                      <input-text-area
                        name="commentaire_accompagnement"
                        libelle="Commentaires"
                        size="4"
                        :value="per.commentaire_accompagnement"
                        @input="
                          (newValue) => {
                            per.commentaire_accompagnement = newValue;
                          }
                        "
                        class="md:col-span-6"
                      />
                      <div
                        class="col-span-3 w-max-content w-max cursor-pointer flex hover:font-semibold"
                        @click="deletePeriode(item.periodes, i)"
                      >
                        <span class="minus-button">
                          <icon name="close" />
                        </span>
                        <span
                          class="text text-gray-600 text-sm ml-3 mt-1.5 mb-10 flex-initial"
                        >
                          Supprimer cet accompagnement
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--END Accompagnement -->
                </transition-group>
                <!-- END content each stage or formation (into the current project) -->
              </div>
            </div>

            <div class="col-span-full grid grid-cols-12 gap-y-10">
              <div class="col-span-6">
                <date-picker
                  :name="'date_commentary' + num"
                  libelle="Date du résultat"
                  format="dd/MM/yyyy"
                  initialview="year"
                  :value="item.date_resultat"
                  @input="
                    (newValue) => {
                      item.date_resultat = newValue;
                    }
                  "
                />
              </div>
              <input-text-area
                :name="'resultat' + num"
                libelle="Résultat du projet"
                :necessary="false"
                size="4"
                :value="item.resultat"
                @input="
                  (newValue) => {
                    item.resultat = newValue;
                  }
                "
                class="col-start-1 col-span-full"
              />
            </div>

            <div
              class="col-span-full w-max-content w-max cursor-pointer flex text-gray-900 hover:text-gray-600 items-center"
              @click="deleteItem(form.projets, num)"
            >
              <span class="minus-button 2xl:h-10 2xl:w-10">
                <icon name="close" />
              </span>
              <span class="text-base ml-3"> Supprimer ce projet </span>
            </div>
          </div>
        </template>
      </list-grid>
    </div>
  </div>
  <div v-else>
    <h3 class="my-15 w-full">
      Aucun projet
    </h3>
    <div v-if="$hasAtLeastOneGuest()">
      <div class="text-gray-600 text-lg text-center">
        <p>Il n'y a aucun projet enregistré.</p>
      </div>
    </div>
    <div v-if="!$hasAtLeastOneGuest()">
      <div class="text-gray-600 text-lg text-center">
        <p>
          Veuillez ajouter un
          <router-link :to="{ name: 'PermissionsGuests' }">
            <span class="cursor-pointer text-indigo-500 underline">invité</span>
          </router-link>
          pour accéder à cette évaluation.
        </p>
        <!-- <p>Pour profiter, faites évoluer votre offre.</p> -->
      </div>
      <div class="flex justify-center w-full">
        <illustration
          class="mt-15"
          name="notAllowed"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import DatePicker from '../../../components/Inputs/DatePicker';

import AddButton from './../../../components/Inputs/AddButton.vue';
import DeleteButton from './../../../components/Inputs/DeleteButton.vue';

import Icon from '../../../components/Icon';
import InfoBulleHover from './../../../components/InfoBulleHover';
import Illustration from './../../../components/Illustration.vue';
import Tag from './../../../components/Tag.vue';
import InfoBulle from '../../../components/InfoBulle.vue';

import ListGrid from '../../../components/AccordionTable/ListGrid.vue';

import Constants from '../../../constants';
import ClickOutside from 'vue-click-outside';
import CircleButton from '../../../components/CircleButton.vue';
import axios from '../../../api';
import JsFileDownload from 'js-file-download';

export default {
  components: {
    CircleButton,
    InputText,
    InputTextArea,
    InputSelect,
    DatePicker,
    Icon,
    InfoBulleHover,
    Illustration,
    DeleteButton,
    AddButton,
    Tag,
    InfoBulle,
    ListGrid,
  },

  props: ['progressbar'],
  name: 'Projets',

  data() {
    return {
      form: {
        projets: [],
      },
      projectDisplayed: -1,
      periodeDisplayed: -1,
      dropDownMenu: false,
      typePeriodes: ['Stage', 'Formation', 'Accompagnement'],
      nbheuresEstimed: 0,

      nbheuresPossible: [],
      nbminutesPossible: [],

      isRealTimeTooltipDisplay: false,
      isEstimatedTimeTooltipDisplay: false,

      constants: Constants,
    };
  },

  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)
    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    async exportToPDF(projet) {
      await axios({
        url: '/api/pdf/neopass/projet/' + this.infosPass.id_pass,
        method: 'POST',
        responseType: 'blob', // Important
        data: {
          projet: projet,
        },
      }).then((response) => {
        let filename = `Projet - ${this.infosPass.firstname} ${this.infosPass.lastname}.pdf`;

        JsFileDownload(response.data, filename);
        //this.typeExportInProgress = '';
      });
    },

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      this.computePossibleHoursMinutes();
      this.sortProjets(false);
    },

    addProject() {
      const idProject = this.form.projets.reduce(
        (acc, projet) => (projet.id && acc < projet.id ? projet.id : acc + 1),
        0
      );

      this.form.projets.unshift({
        id: idProject,
        intitule_projet: '',
        type_projet: '',
        objectifs_projet: '',
        comment_projet: '',
        min_debut_accompagnement_projet: '',
        max_fin_accompagnement_projet: '',
        total_temps_accompagnement: 0,
        etat_decision_projet: '',
        periodes: [],
        referents: [
          {
            accompagnateur_projet: '',
            debut_accompagnement_projet: '',
            fin_accompagnement_projet: '',
            temps_accompagnement_estime_hour: 0,
            temps_accompagnement_estime_minute: 0,
            temps_accompagnement_reel_hour: 0,
            temps_accompagnement_reel_minute: 0,
          },
        ],
        date_resultat: '',
        resultat: '',
      });
      this.dropDownmenu = false;
      this.$refs.listProjects.displayNum(0, true);
    },

    addPeriode(num, type) {
      if (type == 'Stage') {
        var periode = {
          intitule_periode: '',
          type: type,
          debut_periode: '',
          fin_periode: '',
          etat_decision: '',
          nom_structure: '',
          localisation_stage: '',
          referent_stage: '',
          duree_stage: '',
          type_stage: '',
          milieu_stage: '',
          caracteristique_stage: '',
          objectifs_stage: '',
          commentaire_stage: '',
        };
      }

      if (type == 'Formation') {
        var periode = {
          intitule_periode: '',
          type: type,
          debut_periode: '',
          fin_periode: '',
          etat_decision: '',
          organisme_formation: '',
          localisation_formation: '',
          referent_formation: '',
          duree_formation: '',
          type_formation: '',
          modalites_formation: '',
          dispositifs_formation: '',
          dispositifs_formation_precis: '',
          formation_suivie: '',
          formation_suivie_precis: '',
          objectifs_formation: '',
          commentaire_formation: '',
        };
      }

      if (type == 'Accompagnement') {
        var periode = {
          intitule_periode: '',
          type: type,
          debut_periode: '',
          fin_periode: '',
          etat_decision: '',
          organisme_accompagnement: '',
          localisation_accompagnement: '',
          referent_accompagnement: '',
          duree_accompagnement: '',
          type_accompagnement: '',
          modalites_accompagnement: '',
          dispositifs_accompagnement: '',
          dispositifs_accompagnement_precis: '',
          objectifs_accompagnement: '',
          commentaire_accompagnement: '',
        };
      }

      this.dropDownmenu = false;
      this.form.projets[num].periodes.push(periode);
      this.periodeDisplayed = this.form.projets[num].periodes.length - 1;
    },

    addReferent(num) {
      this.form.projets[num].referents.push({
        accompagnateur_projet: '',
        debut_accompagnement_projet: '',
        fin_accompagnement_projet: '',
        temps_accompagnement_estime_hour: 0,
        temps_accompagnement_estime_minute: 0,
        temps_accompagnement_reel_hour: 0,
        temps_accompagnement_reel_minute: 0,
      });
    },

    displayPeriode(numPeriode) {
      if (this.periodeDisplayed == numPeriode) {
        this.periodeDisplayed = -1;
      } else {
        this.periodeDisplayed = numPeriode;
      }
    },

    deleteItem(el, index) {
      el.splice(index, 1);
      this.$refs.listProjects.displayNum(-1);
    },

    deletePeriode(el, index) {
      el.splice(index, 1);
    },

    deleteReferent(el, index) {
      el.splice(index, 1);
    },

    deleteCommentary(el, index) {
      el.splice(index, 1);
    },

    sortProjets(sorting = true) {
      //sort to by minimum date debut (decreasing)
      let projetsDisplayed = this.form.projets[this.projectDisplayed];

      this.form.projets.sort(function (a1, a2) {
        let date1 = new Date(a1.min_debut_accompagnement_projet);
        let date2 = new Date(a2.min_debut_accompagnement_projet);

        if (date1 < date2) {
          return 1;
        } else if (date1 > date2) {
          return -1;
        } else {
          return 0;
        }
      });

      if (sorting) {
        this.$refs.listProjects.displayNum(
          this.form.projets.indexOf(projetsDisplayed),
          true
        );
      }
    },

    sortPeriodes(indexProjet) {
      //sort to by minimum date debut (decreasing)
      let periodeDisplayed =
        this.form.projets[indexProjet].periodes[this.periodeDisplayed];

      this.form.projets[indexProjet].periodes.sort(function (a1, a2) {
        let date1 = new Date(a1.debut_periode);
        let date2 = new Date(a2.debut_periode);

        if (date1 < date2) {
          return 1;
        } else if (date1 > date2) {
          return -1;
        } else {
          return 0;
        }
      });

      this.periodeDisplayed =
        this.form.projets[indexProjet].periodes.indexOf(periodeDisplayed);

      //Scroll back to the current item
      const el = document.getElementById(`periode${indexProjet}`);
      el.scrollIntoView();
    },

    displayDropdownMenu() {
      this.dropDownMenu = !this.dropDownMenu;
    },
    forceHide(e) {
      if (e.target.classList.contains('dropdown-menu')) {
        this.displayDropdownMenu();
      } else {
        if (this.dropDownMenu) {
          this.dropDownMenu = false;
        }
      }
    },

    badDates() {
      window.alert('La date de début doit être antérieure à la date de fin.');
    },

    computePossibleHoursMinutes() {
      // to fill hour and minutes select field
      let limitHour = 999;
      let limitMinute = 59;

      this.nbheuresPossible = [];
      for (let index = -1; index < limitHour; index++) {
        this.nbheuresPossible.push({ value: index + 1 });
      }

      this.nbminutesPossible = [];
      for (let index = -1; index < limitMinute; index++) {
        this.nbminutesPossible.push({ value: index + 1 });
      }
    },

    setMinDateDebutReferent(indexProjet) {
      let listDates = this.form.projets[indexProjet].referents.map(
        (r) => new Date(r.debut_accompagnement_projet)
      );

      this.form.projets[indexProjet].min_debut_accompagnement_projet =
        Math.min(...listDates) &&
        Math.min(...listDates) != '' &&
        Math.min(...listDates) != NaN
          ? new Date(Math.min(...listDates))
          : null;

      this.sortProjets();
    },
    setMaxDateDebutReferent(indexProjet) {
      let listDates = this.form.projets[indexProjet].referents.map(
        (r) => new Date(r.fin_accompagnement_projet)
      );

      this.form.projets[indexProjet].max_fin_accompagnement_projet =
        Math.max(...listDates) &&
        Math.max(...listDates) != '' &&
        Math.max(...listDates) != NaN
          ? new Date(Math.max(...listDates))
          : null;

      this.sortProjets();
    },

    setTotalTempsAccompagnement(indexProjet) {
      let total = 0;

      this.form.projets[indexProjet].referents.forEach((r) => {
        if (r.temps_accompagnement_reel_hour > 0) {
          total += parseInt(r.temps_accompagnement_reel_hour);
        }
        if (r.temps_accompagnement_reel_minute > 0) {
          total += parseInt(r.temps_accompagnement_reel_minute) / 60;
        }
      });

      this.form.projets[indexProjet].total_temps_accompagnement = total;
    },
  },
  computed: {
    Constants() {
      return Constants;
    },
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
    }),

    stageFormation: function () {
      return ['s', 'sf', 'f'];
    },

    idpass() {
      return this.$route.path.split('/form/neopass/')[1].split('/')[0];
    },

    page() {
      return this.$route.path.split('/form/neopass/')[1].split('/')[2];
    },

    totalDuration: function () {
      let durations = {
        total: [
          { h: 0, min: 0 },
          { h: 0, min: 0 },
        ],
        perso: [
          { h: 0, min: 0 },
          { h: 0, min: 0 },
        ],
        socio: [
          { h: 0, min: 0 },
          { h: 0, min: 0 },
        ],
        pro: [
          { h: 0, min: 0 },
          { h: 0, min: 0 },
        ],
      };
      let dureeMin = {
        total: [0, 0],
        perso: [0, 0],
        socio: [0, 0],
        pro: [0, 0],
      };

      this.form.projets.forEach((projet) => {
        projet.referents.forEach((referent) => {
          switch (projet.type_projet) {
          case 'Personnel':
            dureeMin.perso[0] +=
                parseInt(referent.temps_accompagnement_reel_minute) +
                parseInt(referent.temps_accompagnement_reel_hour) * 60;
            dureeMin.perso[1] +=
                parseInt(referent.temps_accompagnement_estime_minute) +
                parseInt(referent.temps_accompagnement_estime_hour) * 60;

            durations.perso[0].min = dureeMin.perso[0] % 60;
            durations.perso[0].h = Math.trunc(dureeMin.perso[0] / 60);
            durations.perso[1].min = dureeMin.perso[1] % 60;
            durations.perso[1].h = Math.trunc(dureeMin.perso[1] / 60);
            break;

          case 'Socio-professionnel':
            dureeMin.socio[0] +=
                parseInt(referent.temps_accompagnement_reel_minute) +
                parseInt(referent.temps_accompagnement_reel_hour) * 60;
            dureeMin.socio[1] +=
                parseInt(referent.temps_accompagnement_estime_minute) +
                parseInt(referent.temps_accompagnement_estime_hour) * 60;

            durations.socio[0].min = dureeMin.socio[0] % 60;
            durations.socio[0].h = Math.trunc(dureeMin.socio[0] / 60);
            durations.socio[1].min = dureeMin.socio[1] % 60;
            durations.socio[1].h = Math.trunc(dureeMin.socio[1] / 60);
            break;

          case 'Professionnel':
            dureeMin.pro[0] +=
                parseInt(referent.temps_accompagnement_reel_minute) +
                parseInt(referent.temps_accompagnement_reel_hour) * 60;
            dureeMin.pro[1] +=
                parseInt(referent.temps_accompagnement_estime_minute) +
                parseInt(referent.temps_accompagnement_estime_hour) * 60;

            durations.pro[0].min = dureeMin.pro[0] % 60;
            durations.pro[0].h = Math.trunc(dureeMin.pro[0] / 60);
            durations.pro[1].min = dureeMin.pro[1] % 60;
            durations.pro[1].h = Math.trunc(dureeMin.pro[1] / 60);
            break;
          }
          dureeMin.total[0] +=
            parseInt(referent.temps_accompagnement_reel_minute) +
            parseInt(referent.temps_accompagnement_reel_hour) * 60;
          dureeMin.total[1] +=
            parseInt(referent.temps_accompagnement_estime_minute) +
            parseInt(referent.temps_accompagnement_estime_hour) * 60;

          durations.total[0].min = dureeMin.total[0] % 60;
          durations.total[0].h = Math.trunc(dureeMin.total[0] / 60);

          durations.total[1].min = dureeMin.total[1] % 60;
          durations.total[1].h = Math.trunc(dureeMin.total[1] / 60);
        });
      });

      return durations;
    },
  },

  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
